import React from 'react';
import { useLocation } from 'react-router-dom';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/layout/AppSidebar';
import Header from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  
  // Apply overflow-hidden only on chat page, allow scrolling on other pages
  const isChatPage = location.pathname === '/';
  const mainOverflowClass = isChatPage ? 'overflow-hidden' : 'overflow-auto';
  
  return (
    <SidebarProvider defaultOpen={false}>
      <div className="h-screen flex w-full bg-background overflow-hidden">
        <AppSidebar />
        <div className="flex-1 flex flex-col h-screen min-w-0">
          <Header />
          <main className={`flex-1 ${mainOverflowClass} bg-background`}>
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Layout;